import { getContactCenterStyles } from './variantStyles/contactCenter';
import { getContactCenterScriptStyles } from './variantStyles/contactCenterScript';
import { getErrorStyles } from './variantStyles/error';
import { getInformativeStyles } from './variantStyles/informative';
import { getSuccessStyles } from './variantStyles/success';
import { getWarningStyles } from './variantStyles/warning';
export const getMessageStyles = (FOUNDATIONS, FONT) => {
    return {
        ...getInformativeStyles(FOUNDATIONS, FONT),
        ...getSuccessStyles(FOUNDATIONS, FONT),
        ...getWarningStyles(FOUNDATIONS, FONT),
        ...getErrorStyles(FOUNDATIONS, FONT),
        ...getContactCenterStyles(FOUNDATIONS, FONT),
        ...getContactCenterScriptStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map